var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-event_cal",class:{ 'c-event_cal--loading' : _vm.isLoading }},[(_vm.config.contentHeight)?_c('full-calendar',{ref:"calendar",staticClass:"c-event_cal__calendar",attrs:{"event-sources":_vm.eventSources,"events":_vm.compEvents,"config":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }